import React from "react";
import { components } from "react-select";
import Select from "react-select";
import { CircularAvatar, DropDown } from "../../../commons";
import { ProgressDropDown } from "../../../../constant/hrms/recruitmentModule/recruitmentTrackerDropdown";
import { InputDetailsErrorType } from "./index";
import { DropDownType } from "../../../../redux/auth/authTypes";
import { Label } from "reactstrap";
import ReactDatePicker from "react-datepicker";
import { CalenderIcon } from "../../../Icon";
import moment from "moment";

type AppProps = {
  positionDetails: any;
  finalBranchDataList: any;
  handleBranceDetailsChange: (data: any) => void;
  branchText: string;
  branchFetching: boolean;
  setBranchOffset: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  setBranchText: React.Dispatch<React.SetStateAction<string>>;
  handleProgressChange: (data: any) => void;
  setRecruiterOffset: React.Dispatch<React.SetStateAction<number>>;
  recruiterLimit: number;
  recruiterOffset: number;
  recruiterText: string;
  finalRecruiterList: any;
  setRecruiterText: React.Dispatch<React.SetStateAction<string>>;
  userFetching: boolean;
  handleRecruiterDropdownChange: (data: any) => void;
  jobPositionFetching: boolean;
  finalJobPositionList: any;
  setJobPositionOffset: React.Dispatch<React.SetStateAction<number>>;
  jobPositionText: string;
  setJobPositionText: React.Dispatch<React.SetStateAction<string>>;
  handleJobPositionChange: (data: any) => void;
  handleDepartmentChange: (data: any) => void;
  handleOfferedJobPosition: (data: any) => void;
  inputDetailsError: InputDetailsErrorType;
  finalDepartmentList: DropDownType[] | [];
  departmentText: any;
  setDepartmentText: any;
  setDepartmentOffset: any;
  handleProposedJoiningDateChange: (data: any) => void;
};

const PositionDetails = ({
  positionDetails,
  finalBranchDataList,
  handleBranceDetailsChange,
  handleProgressChange,
  branchText,
  branchFetching,
  setBranchOffset,
  limit,
  setBranchText,
  setRecruiterOffset,
  recruiterLimit,
  recruiterOffset,
  recruiterText,
  finalRecruiterList,
  setRecruiterText,
  userFetching,
  handleRecruiterDropdownChange,
  jobPositionFetching,
  finalJobPositionList,
  setJobPositionOffset,
  jobPositionText,
  setJobPositionText,
  handleJobPositionChange,
  handleOfferedJobPosition,
  inputDetailsError,
  finalDepartmentList,
  departmentText,
  setDepartmentText,
  setDepartmentOffset,
  handleDepartmentChange,
  handleProposedJoiningDateChange,
}: AppProps) => {
  const branchIsLoading = branchFetching && branchText?.length ? true : false;
  const userIsLoading = userFetching && recruiterText?.length ? true : false;

  const checkBottom = (e: any) => {
    setBranchOffset((prv: any) => prv + limit);
  };
  const checkPositionBottom = (e: any) => {
    setJobPositionOffset((prv: any) => prv + limit);
  };
  const checkRecruiterBottom = (e: any) => {
    setRecruiterOffset((prv: any) => prv + recruiterLimit);
  };

  const checkDepartmentBottom = () => {
    setDepartmentOffset((prv: any) => prv + recruiterLimit);
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };
  const dropDownStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: "300px",
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: "77%",
    }),
    container: (provided: any) => ({
      ...provided,
      width: 320,
      position: "absolute",
    }),
  };

  const getColorForStyle = (style: string): string => {
    switch (style) {
      case "new":
        return " #2080f6";
      case "screening":
        return "#f3a119";
      case "accpeted":
        return " #82b01f";
      case "pending":
        return "#744bd1";
      case "pending":
        return "#ede6fc";
      case "rejected":
        return "#e7733e";
      case "withdrawn":
        return "#262a44";
      default:
        return "#ffffff";
    }
  };

  const getBackColorForStyle = (style: string): string => {
    switch (style) {
      case "new":
        return " #e3efff";
      case "screening":
        return "#faedd8";
      case "accpeted":
        return "#e7f0d4";
      case "pending":
        return "#ede6fc";
      case "rejected":
        return "#fde0d3";
      case "withdrawn":
        return "#e3e9ee";
      default:
        return "#ffffff";
    }
  };

  const customStyles = {
    option: (baseStyles: any, { data }: any) => {
      return {
        ...baseStyles,
        backgroundColor: getBackColorForStyle(data.style),
        color: getColorForStyle(data.style),
        padding: "6px 15px 6px 15px",
        margin: "0px 0px 8px 0px",
        borderRadius: "16px",
        fontSize: "14px",
        fontWeight: "500",
        width: "fit-content",
      };
    },
  };

  return (
    <>
      <div className="mb-2" style={{ marginTop: "29px" }}>
        <h5 style={{ fontSize: "15px", fontWeight: "600" }}>
          POSITION DETAILS
        </h5>
      </div>
      <div className="row">
        <div className="col-md-3">
          <label className="mb-1" htmlFor="department">
            Department
          </label>
          <div className="position-relative">
            <Select
              className="dropdown"
              placeholder={"Select..."}
              value={positionDetails?.department}
              options={finalDepartmentList}
              onChange={handleDepartmentChange}
              isSearchable={true}
              isLoading={branchFetching && departmentText?.length > 0}
              onMenuClose={() => setDepartmentOffset(0)}
              onMenuScrollToBottom={(e: any) => checkDepartmentBottom()}
              onInputChange={(e) => {
                setDepartmentText(e);
              }}
            />
          </div>
        </div>

        <div className="col-md-3">
          <label className="mb-1" htmlFor="">
            Job Position <span className="color-red">*</span>
          </label>
          <Select
            className={`${
              inputDetailsError?.jobPositionError ? "error-border rounded" : ""
            }`}
            options={finalJobPositionList}
            value={positionDetails?.jobPosition}
            onChange={handleJobPositionChange}
            isSearchable={true}
            isLoading={jobPositionFetching && jobPositionText?.length > 0}
            onMenuClose={() => setJobPositionOffset(0)}
            onMenuScrollToBottom={(e: any) => checkPositionBottom(e)}
            onInputChange={(e) => {
              setJobPositionText(e);
            }}
          />
          {!!inputDetailsError?.jobPositionError && (
            <small className="text-danger">
              {inputDetailsError?.jobPositionError}
            </small>
          )}
        </div>
        <div className="col-md-3">
          <label className="mb-1" htmlFor="">
            Offered Job Position
          </label>
          <Select
            className={`${
              inputDetailsError?.jobPositionError ? "error-border rounded" : ""
            }`}
            options={finalJobPositionList}
            value={positionDetails?.offeredJobPosition}
            onChange={handleOfferedJobPosition}
            isSearchable={true}
            isLoading={jobPositionFetching && jobPositionText?.length > 0}
            onMenuClose={() => setJobPositionOffset(0)}
            onMenuScrollToBottom={(e: any) => checkPositionBottom(e)}
            onInputChange={(e) => {
              setJobPositionText(e);
            }}
          />
        </div>
        <div className="col-md-3">
          <label className="mb-1" htmlFor="">
            Job Location <span className="color-red">*</span>
          </label>
          <Select
            className={`${
              inputDetailsError?.jobLocationError ? "error-border rounded" : ""
            }`}
            options={finalBranchDataList}
            value={positionDetails?.jobLocation}
            onChange={handleBranceDetailsChange}
            isSearchable={true}
            isLoading={branchIsLoading}
            onMenuClose={() => setBranchOffset(0)}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            onInputChange={(e) => {
              setBranchText(e);
            }}
          />
          {!!inputDetailsError?.jobLocationError && (
            <small className="text-danger">
              {inputDetailsError?.jobLocationError}
            </small>
          )}
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-3">
          <label className="mb-1" htmlFor="contactType">
            Progress <span className="color-red">*</span>
          </label>
          <div>
            <DropDown
              options={ProgressDropDown}
              value={positionDetails?.progress}
              handleChange={handleProgressChange}
              extraClasses={`${
                inputDetailsError?.jobprogressError
                  ? "error-border rounded"
                  : ""
              }`}
              style={customStyles}
            />
            {!!inputDetailsError?.jobprogressError && (
              <small className="text-danger">
                {inputDetailsError?.jobprogressError}
              </small>
            )}
          </div>
        </div>

        <div className="col-md-3">
          <label className="mb-1" htmlFor="">
            Recruiter
          </label>
          <Select
            // styles={dropDownStyle}
            options={finalRecruiterList}
            value={positionDetails?.recruiter}
            components={{ Option }}
            onChange={(e) => handleRecruiterDropdownChange(e)}
            isSearchable={true}
            isLoading={userFetching && recruiterText?.length > 0}
            onMenuClose={() => {
              setRecruiterOffset(0);
            }}
            onMenuScrollToBottom={(e: any) => checkRecruiterBottom(e)}
            // isDisabled={isDisabled}
            onInputChange={(e) => {
              setRecruiterText(e);
            }}
          />
        </div>
        <div className="col-md-3">
          <label className="mb-1" htmlFor="">
            Proposed Joining Date
          </label>
          <div className="form-group">
          <div className="date-picker-wraper mr-0">
            <Label className="m-0 p-0 w-100">
              <ReactDatePicker
                dateFormat="dd-MM-yyyy"
                selected={
                  positionDetails?.proposedJoiningDate
                    ? new Date(
                        moment(`${positionDetails?.proposedJoiningDate}`, "DD-MM-YYYY").format(
                          "YYYY-MM-DD"
                        )
                      )
                    : null
                }
                onChange={(e: any) => {
                  if(e != undefined){
                    handleProposedJoiningDateChange?.(
                      moment(e)?.format("DD-MM-YYYY")
                    );
                  }
                  else{
                    handleProposedJoiningDateChange(null)
                  }
                }
              }
                fixedHeight
                showMonthDropdown
                showYearDropdown
                name="proposedJoiningDate"
                placeholderText="Choose Date"
                className="form-control"
                // value={positionDetails?.proposedJoiningDate}
              />
              <span
                className="calender-icon"
                style={{
                  right: "30px",
                  top: "30px",
                  cursor: "pointer",
                }}
              >
                <CalenderIcon />
              </span>
            </Label>

            {/* <div>
              {!!dateError && (
                <small className="text-danger">{dateError}</small>
              )}
            </div> */}
          </div>
          </div>
          
        </div>
      </div>
    </>
  );
};

export default PositionDetails;
